module.exports = __webpack_public_path__ + "static/media/Letter Writing to an Employer.ebb793ca.pdf";